if ( typeof SearchForm !== 'function' ) {
	class SearchForm extends HTMLElement {

		constructor() {

			super();	
			this.cachedResults = {};
			this.facetCache = {};
			this.input = this.querySelector('[data-js-search-input]');
			this.predictiveSearchResults = this.querySelector('[data-js-search-results]');
			this.results = [];
			this.preloader = false;

			this.bindFacets();

			if ( KROWN.settings.predictive_search_enabled != "false" ) {

				let inputValue = this.input.value;
				this.input.addEventListener('keyup', debounce(e=>{
					if ( this.input.value != inputValue ) {
						inputValue = this.input.value;
						this.getSearchResults(this.input.value.trim());
					} else if ( this.input.value == '' ) {
						this.clearSearchResults();
					}
				},150));

				this.input.addEventListener('keydown', e=>{
					if ( this.a11yIndex != -1 ) {
						if (
							e.keyCode === window.KEYCODES.UP ||
							e.keyCode === window.KEYCODES.DOWN ||
							e.keyCode === window.KEYCODES.RETURN
						) {
							e.preventDefault();
						}
					}
				});

				this.input.addEventListener('keyup', e=>{
					if (e.keyCode === window.KEYCODES.UP) {
						this.navigateThrough('UP');
						return true;
					}

					if (e.keyCode === window.KEYCODES.DOWN) {
						this.navigateThrough('DOWN');
						return true;
					}

					if (e.keyCode === window.KEYCODES.RETURN) {
						if ( this.a11yIndex != -1 ) {
							document.location.href = this.results[this.a11yIndex].tagName == "A" ? this.results[this.a11yIndex].href : this.results[this.a11yIndex].querySelector('a').href;
						}
					}
				})

			}

		}

		getSearchResults(query="") {

			this.preloadSearchResults();

			const queryKey = query.replace(" ", "-").toLowerCase();
			if (this.cachedResults[queryKey]) {
				this.renderSearchResults(this.cachedResults[queryKey]);
				return;
			}

			this.a11yIndex = -1;

			fetch(`${KROWN.settings.routes.predictive_search_url}?q=${encodeURIComponent(query)}&section_id=helper-predictive-search`)
				.then(response=>{
					if (!response.ok) {
						var error = new Error(response.status);
						this.clearSearchResults();
						throw error;
					}
					return response.text();
				})
				.then(text=>{
					const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-predictive-search').innerHTML;
					this.cachedResults[queryKey] = results;
					this.renderSearchResults(results);
				})	
				.catch((e) => {
					throw e;
				}); 

		}

		clearSearchResults(){
			this.predictiveSearchResults.innerHTML = '';
			this.preloader = false;
			this.results = [];
		}

		preloadSearchResults(){
			if ( ! this.preloader ) {
				this.preloader = true;
				this.predictiveSearchResults.innerHTML = KROWN.settings.predictive_search_placeholder;
			}
		}

		renderSearchResults(results){
			this.predictiveSearchResults.innerHTML = results;
			this.preloader = false;
			this.results = this.predictiveSearchResults.querySelectorAll('[data-js-search-item]');
			this.afterRender();
		}

		// ----- Merchandised search: category/brand/range pills swap the product grid in place -----
		bindFacets(){
			if ( ! this.predictiveSearchResults ) return;
			this.predictiveSearchResults.addEventListener('click', e=>{
				const pill = e.target.closest('[data-psearch-facet], [data-psearch-query]');
				if ( ! pill || ! this.predictiveSearchResults.contains(pill) ) return;
				e.preventDefault();
				this.loadPill(pill);
			});
		}

		// After each panel render, load the default product column in the collection's own sort
		// order (CK 23 Oct 26, Lisa: honour the manual order she sets per brand in admin).
		afterRender(){
			const main = this.predictiveSearchResults.querySelector('[data-psearch-main][data-psearch-collection]');
			if ( ! main ) return;
			const grid = main.querySelector('[data-psearch-grid]');
			if ( grid ) grid.classList.add('psearch-grid--pending');
			const def = this.predictiveSearchResults.querySelector('[data-psearch-autoload]');
			if ( def ) {
				this.loadPill(def);
			} else {
				const handle = main.getAttribute('data-psearch-collection');
				const labelEl = main.querySelector('[data-psearch-label-el]');
				this.swapInto(grid, labelEl, null, '/collections/' + handle + '?section_id=psearch-grid', 'psearch-grid');
			}
		}

		loadPill(pill){
			const holder = this.predictiveSearchResults;
			const main = holder.querySelector('[data-psearch-main]');
			if ( ! main ) return;
			const grid = main.querySelector('[data-psearch-grid]');
			const labelEl = main.querySelector('[data-psearch-label-el]');

			holder.querySelectorAll('.psearch-chip').forEach(c=>c.classList.remove('active'));
			pill.classList.add('active');

			// CK 22 Sep 26: 'View all results' follows the chosen pill (Lisa: MUK > Styling > View all showed every Muk product)
			const viewAll = holder.querySelector('.psearch-all');
			if ( viewAll ) {
				const f = pill.getAttribute('data-psearch-facet'), q = pill.getAttribute('data-psearch-query'), lab = pill.getAttribute('data-psearch-label');
				if ( f ) viewAll.setAttribute('href', f);
				else if ( q ) viewAll.setAttribute('href', KROWN.settings.routes.search_url + '?q=' + encodeURIComponent(q));
				if ( lab && (f || q) ) viewAll.innerHTML = 'View all ' + lab.replace(/[<>&]/g, '') + ' &rarr;';
			}

			const label = pill.getAttribute('data-psearch-label');
			const facet = pill.getAttribute('data-psearch-facet');
			const query = pill.getAttribute('data-psearch-query');
			let url, sectionId;
			if ( facet ) {
				// real collection (+optional tag) -> collection's own sort order
				url = facet + (facet.indexOf('?') > -1 ? '&' : '?') + 'section_id=psearch-grid';
				sectionId = 'psearch-grid';
			} else if ( query ) {
				// search-defined range -> reuse predictive endpoint (relevance), pull its grid
				url = KROWN.settings.routes.predictive_search_url + '?q=' + encodeURIComponent(query) + '&section_id=helper-predictive-search';
				sectionId = 'helper-predictive-search';
			} else {
				return;
			}
			this.swapInto(grid, labelEl, label, url, sectionId);
		}

		swapInto(grid, labelEl, label, url, sectionId){
			if ( label && labelEl ) labelEl.textContent = label;
			if ( ! grid ) return;
			grid.classList.add('psearch-grid--pending');

			const apply = html => {
				grid.innerHTML = html;
				grid.classList.remove('psearch-grid--pending');
				this.results = this.predictiveSearchResults.querySelectorAll('[data-js-search-item]');
			};

			if ( this.facetCache[url] ) { apply(this.facetCache[url]); return; }

			fetch(url)
				.then(r=>r.text())
				.then(text=>{
					const doc = new DOMParser().parseFromString(text, 'text/html');
					const sec = doc.querySelector('#shopify-section-' + sectionId);
					let html = '';
					if ( sec ) {
						if ( sectionId === 'helper-predictive-search' ) {
							const g = sec.querySelector('[data-psearch-grid]');
							html = g ? g.innerHTML : '';
						} else {
							html = sec.innerHTML;
						}
					}
					this.facetCache[url] = html;
					apply(html);
				})
				.catch(()=>{ grid.classList.remove('psearch-grid--pending'); });
		}

		navigateThrough(direction){

			if ( this.a11yIndex == -1 ) {
				this.a11yIndex = 0;
			} else {
				this.results[this.a11yIndex].classList.remove('active');
				if ( direction == 'UP' ) {
					if ( this.a11yIndex - 1 >= -1 ) {
						this.a11yIndex--;
					} 
				} else if ( direction == 'DOWN' ) {
					if ( this.a11yIndex + 1 < this.results.length ) {
						this.a11yIndex++;
					} 
				}
			}

			if ( this.a11yIndex >= 0 ) {
				this.results[this.a11yIndex].classList.add('active');
				document.querySelector('[data-js-search-results-holder]').scrollTop = this.results[this.a11yIndex].offsetTop - 200;
			} else {
				document.querySelector('[data-js-search-results-holder]').scrollTop = 0;
			}

		}

	}

  if ( typeof customElements.get('search-form') == 'undefined' ) {
		customElements.define('search-form', SearchForm);
	}

}